import { ChatFilters } from 'find-and-filter-data/search-and-filter-schema/protected';
import { STATUS } from '../constants/FilterKeys';
export const DEFAULT_CHAT_FILTERS = ChatFilters({
  [STATUS]: null
});